"use client";

import { Post } from "@/types/post.types";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CommonCard from "../commonCard/CommonCard";
import "./style.css";
import Link from "next/link";
import { useRef, useState } from "react";
import { NavBtn } from "../navButton/NavBtn";

interface PressReleaseProps {
  post: Post[];
}

export default function PressRelease({ post }: PressReleaseProps) {
  const [hoverPrev, setHoverPrev] = useState(false);
  const [hoverNext, setHoverNext] = useState(false);
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <section
      className=" bg-black px-0 py-md-5 py-5"
      style={{ overflow: "visible" }}
    >
      <div
        className="gh-container"
        // style={{
        //   maxWidth: "1418px",
        //   margin: "0 auto",
        // }}
      >
        {/* Title */}
        <h2 className="tag-section-title mb-3 text-white px-2">
          Press Release
        </h2>
        <p className="tag-section-description pb-md-4 text-white px-2">
          Latest updates and breakthroughs in Press Release.
        </p>

        {/* Slider wrapper */}
        <div style={{ position: "relative" }}>
          <Swiper
            modules={[Navigation]}
            spaceBetween={24}
            slidesPerView={1}
            loop
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              // @ts-ignore
              swiper.params.navigation.prevEl = prevRef.current;
              // @ts-ignore
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            observer={true}
            observeParents={true}
            resizeObserver={true}
          >
            {post?.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="breaking-news-card">
                  <CommonCard
                    authorName={item.author}
                    titleClassName="breaking-news default-hover text-white"
                    publishDate={item.date}
                    titleText={item.title}
                    imgSrc={item.image || "/image-not-found.png"}
                    category_name={item.category_name || ""}
                    category_slug={item.category_slug || ""}
                    category_color={item.category_color || ""}
                    sub_category_name={item.sub_category_name || ""}
                    sub_category_slug={item.sub_category_slug || ""}
                    sub_category_color={item.sub_category_color || ""}
                    cardLink={`/${item.url}`}
                    authorSlug={`${item.author_slug}` || ""}
                    authorSlugClassName="authors-slug-swiper"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <NavBtn
            ref={prevRef}
            direction="prev"
            hover={hoverPrev}
            className="press-release-prev"
            onMouseEnter={() => setHoverPrev(true)}
            onMouseLeave={() => setHoverPrev(false)}
          />

          <NavBtn
            ref={nextRef}
            direction="next"
            hover={hoverNext}
            className="press-release-next"
            onMouseEnter={() => setHoverNext(true)}
            onMouseLeave={() => setHoverNext(false)}
          />
        </div>
        <div className="d-flex justify-content-center justify-content-md-end mt-3">
          {post?.[0]?.category_slug && (
            <Link
              href={`/${post[0].category_slug}`}
              className="newsletter-submit-loading-button d-inline-flex align-items-center gap-2 px-3 py-2"
              style={{ width: "fit-content" }}
              aria-label={`Read more about ${post[0].category_name || post[0].category_slug}`}
            >
              <span>
                Read more
                <span className="visually-hidden">
                  {" "}
                  about {post[0].category_name || post[0].category_slug}
                </span>
              </span>

              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ display: "block" }}
              >
                <path d="M5 12h14" />
                <path d="M12 5l7 7-7 7" />
              </svg>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
